/* Mengen-Stepper fuer Warenkorb-Positionen (Muster wie Quick-Order).
   Die +/- Buttons passen den Wert an; nach einer kurzen Pause wird ein
   change-Event ausgeloest, das die bestehende <line-item-quantity>-Logik
   des Themes uebernimmt. So loesen mehrere schnelle Klicks nur ein
   einziges Cart-Update aus. */
(() => {
  if (window.customElements.get('ds-quantity-stepper')) return;

  const DEBOUNCE_MS = 500;

  class DsQuantityStepper extends HTMLElement {
    connectedCallback() {
      this._input = this.querySelector('input');
      this._abortController = new AbortController();
      const { signal } = this._abortController;

      this.querySelectorAll('button[data-step]').forEach((button) => {
        button.addEventListener(
          'click',
          () => this._step(button.dataset.step === 'up' ? 1 : -1),
          { signal }
        );
      });

      // Direkte Eingaben ebenfalls nach einer kurzen Tipp-Pause uebernehmen,
      // ohne dass das Feld zuerst verlassen werden muss.
      this._input?.addEventListener('input', () => this._scheduleChange(), { signal });

      // Tippt der Nutzer direkt ins Feld, feuert das native change sofort —
      // ein noch offener Stepper-Timer darf dann kein zweites Update senden.
      this._input?.addEventListener('change', () => clearTimeout(this._timer), { signal });
    }

    disconnectedCallback() {
      this._abortController.abort();
      clearTimeout(this._timer);
    }

    _step(delta) {
      if (!this._input) return;

      const current = parseInt(this._input.value, 10) || 1;
      const min = parseInt(this._input.min, 10) || 1;
      const max = parseInt(this._input.max, 10) || Infinity;
      const next = Math.min(max, Math.max(min, current + delta));

      if (next === current) return;

      this._input.value = next;

      this._scheduleChange();
    }

    _scheduleChange() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this._input.dispatchEvent(new Event('change', { bubbles: true }));
      }, DEBOUNCE_MS);
    }
  }

  window.customElements.define('ds-quantity-stepper', DsQuantityStepper);
})();
